import { AxiosInstance } from "axios";
import { baseURL } from "../services/api";
import { TimeSlotRequest } from "./types";

export const timeSlotsAPI = (api: AxiosInstance) => ({
  fetchTimesSlots: (timeSlotsRequest: TimeSlotRequest) =>
    api.post(`${baseURL}/get-appointment-proposals`, timeSlotsRequest),
});
